<div class="container">
  <div class="wrapper">
    <h1 class="pageTitle">{{ pageTitle }}</h1>
    <app-notifications
      [notification]="'locations_page_notification_banner_parent'"
    ></app-notifications>
    <hr />

    <div class="row">
      <div class="mr-4" *ngFor="let location of locations">
        <div
          class="card locations-list"
          [ngClass]="{
            'selected-location-list': selectedLocation?.id === location?.id
          }"
        >
          <!-- The whole card is the control, so the click, the keyboard
               handlers and the accessible name all live on one element. -->
          <div
            class="location-item"
            [ngClass]="{
              'selected-location': selectedLocation?.id === location?.id
            }"
            tabindex="0"
            role="button"
            [attr.aria-pressed]="selectedLocation?.id === location?.id"
            attr.aria-label="Select location {{ location.name }}"
            (click)="
              updateMapView(location.address.lat, location.address.long);
              selectLocation(location)
            "
            (keydown.enter)="
              updateMapView(location.address.lat, location.address.long);
              selectLocation(location)
            "
            (keydown.space)="
              $event.preventDefault();
              updateMapView(location.address.lat, location.address.long);
              selectLocation(location)
            "
          >
            <div class="card-location-header">
              <span class="material-icons" aria-hidden="true"> location_on </span>
              <h2>{{ location.name }}</h2>
            </div>
            <em>{{ location.description }}</em>
            <p class="mt-2" *ngIf="location?.address">
              <span *ngIf="location?.address.address1"
                >{{ location.address.address1 }}, <br
              /></span>
              <span *ngIf="location?.address.address2"
                >{{ location.address.address2 }}, <br
              /></span>
              <span *ngIf="location?.address.address3"
                >{{ location.address.address3 }}, <br
              /></span>
              <span *ngIf="location?.address.address4"
                >{{ location.address.address4 }}, <br
              /></span>
              <span *ngIf="location?.address.address5"
                >{{ location.address.address5 }}, <br
              /></span>
              <span *ngIf="location?.address.postcode"
                >{{ location.address.postcode }} <br
              /></span>
            </p>

            <p class="phone">
              <span *ngIf="location?.address.phone"
                ><span
                  class="material-icons"
                  aria-hidden="true"
                  style="font-size: small !important"
                >
                  phone
                </span>
                {{ location.address.phone }} <br />
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="mt-4 col-sm-6" *ngIf="mapsRequired">
        <app-leaflet-map *ngIf="locations"></app-leaflet-map>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-6">
        <button
          class="btn btn-primary"
          (click)="routerGoBack()"
          tabindex="0"
          role="button"
          aria-label="Go back to services page"
        >
          {{ 'COMMON.BACK' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
